import { cva } from 'class-variance-authority'

export const dialogStyles = cva(
  `
    rounded-xl
    p-6

  `,
  {
    variants: {
      color: {
        level0: 'bg-neutral-0 border border-neutral-200',
        level1: 'bg-neutral-100',
        priority: 'bg-orange-0',
        emphasis: 'bg-moss-0',
        brand: 'bg-moss-300 text-neutral-0',
        success: 'bg-green-0',
        warning: 'bg-yellow-0',
        danger: 'bg-red-0',
      },
    },
    defaultVariants: {
      color: 'level0',
    },
  }
)

export const dismissStyles = cva(
  `
    rounded-xl
    bg-dialog
    p-6
  `
)

export const overlayStyles = cva(
  `
    fixed
    inset-0
    z-200
    bg-[rgba(0,0,0,0.5)]
    data-[state=open]:animate-in
    data-[state=closed]:animate-out
    data-[state=closed]:fade-out-0
    data-[state=open]:fade-in-0
  `
)

export const contentStyles = cva(
  `
    flex
    flex-col
    fixed
    left-[50%]
    top-[50%]
    z-50
    w-full
    max-w-lg
    max-h-[90vh] 
    overflow-y-auto
    translate-x-[-50%]
    translate-y-[-50%]
    gap-4
    border
    my-4
    border-neutral-200
    rounded-xl
    p-6
    bg-neutral-0
    shadow-lg
    duration-200
    data-[state=open]:animate-in
    data-[state=closed]:animate-out
    data-[state=closed]:fade-out-0
    data-[state=open]:fade-in-0
    data-[state=closed]:slide-out-to-top-full
    data-[state=open]:slide-in-from-top-full
  `,
  {
    variants: {
      size: {
        sm: 'max-w-[440px]',
        md: 'max-w-[512px]',
        lg: 'max-w-[580px]',
        xl: 'max-w-[1000px]',
      },
    },
    defaultVariants: {
      size: 'lg',
    },
  }
)

export const closeStyles = cva(
  `
    absolute
    right-0
    top-1
    rounded-sm
    opacity-70
    ring-offset-background
    transition-opacity
    hover:opacity-100
    focus:outline-none
    focus:ring-2
    focus:ring-ring
    focus:ring-offset-2
    disabled:pointer-events-none
    data-[state=open]:bg-accent
    data-[state=open]:text-muted-foreground
  `
)

export const footerStyles = cva(
  `
    flex
    flex-col-reverse
    sm:flex-row
    sm:justify-end
    sm:space-x-2
    gap-2
  `
)

export const titleStyles = cva(
  `
    text-lg
    font-semibold
    leading-none
    tracking-tight
  `,
  {
    variants: {
      variant: {
        h1: 'h1',
        displayMd: 'display-md',
      },
      center: {
        true: 'items-center justify-center',
      },
    },
    defaultVariants: {
      variant: 'h1',
      center: false,
    },
  }
)

export const subTitleStyles = cva('body-sm text-neutral-500', {
  variants: {
    center: {
      true: 'text-center',
    },
  },
  defaultVariants: {
    center: false,
  },
})

export const descriptionStyles = cva(
  `
    text-sm
    text-muted-foreground
  `,
  {
    variants: {
      center: {
        true: 'items-center justify-center',
      },
    },
    defaultVariants: {
      center: false,
    },
  }
)
